import createReactComponent from '../createReactComponent';
export default createReactComponent('four', 'Four', [["path",{"d":"M12.917 7c-1.042 3.75-4.167 6.875-4.167 6.875H15M13.438 17v-5","key":"svg-0"}]]);